import reactDom from './morph/react-dom.js'
import reactNative from './morph/react-native.js'
import reactPdf from './morph/react-pdf.js'

export default {
  'react-dom': reactDom,
  'react-native': reactNative,
  'react-pdf': reactPdf,
}
